export { default as NPopconfirm, popconfirmProps } from './src/Popconfirm';
